export const ActivitiesRelatedToEnum = {
  unit: {
    key: 1,
    value: 'unit',
  },
  lead: {
    key: 2,
    value: 'lead',
  },
  workOrder: {
    key: 3,
    value: 'work-order',
  },
  portfolio: {
    key: 4,
    value: 'portfolio',
  },
  maintenanceContract: {
    key: 5,
    value: 'maintenance-contract',
  },
};
